import { apiRequest } from '@/utils/api-request';
import {
  NotificationPreference,
  NotificationPreferencesResponse,
} from '@/types/notification-types';
import * as Sentry from '@sentry/react';

export async function updateNotificationPreferences(
  orgId: string,
  items: NotificationPreference[],
): Promise<NotificationPreferencesResponse> {
  try {
    const response = await apiRequest<NotificationPreferencesResponse>({
      url: `/orgs/${orgId}/notification-preferences`,
      target: 'notifications',
      method: 'PUT',
      body: { items },
    });

    return response.data ?? { items };
  } catch (error) {
    Sentry.captureException(error, {
      extra: { context: 'update-notification-preferences', orgId },
    });
    throw error;
  }
}
